import { useLingui } from '@lingui/react/macro';

import { Alert } from '@/components/Alert';

type OverlappingRoot = { websiteUrl: string };

/**
 * Shared "this path overlaps N other tracked roots" warning — the add-website
 * panel and the promote-to-tracked-website modal both surface it from the
 * same `documentFolders.checkWebsiteRootOverlap` query.
 */
export function OverlappingRootsAlert({
  overlappingRoots,
}: {
  overlappingRoots: OverlappingRoot[];
}) {
  const { t } = useLingui();

  if (overlappingRoots.length === 0) {
    return null;
  }

  return (
    <Alert
      variant='warning'
      title={t`Overlapping tracked roots`}
      description={t`This path overlaps ${overlappingRoots
        .map(root => root.websiteUrl)
        .join(
          ', ',
        )}. The longest matching path owns each URL — nested roots carve those pages out of the broader site.`}
    />
  );
}
